import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'


export async function getWinner(wagerId){
    let winner;
    winner = await ContractStore.call("Wagers", "getWinner", [wagerId]);   
    return winner;
}


export async function getSettled(wagerId){
    let settled;
    settled = await ContractStore.call("Wagers", "getSettled", [wagerId]);   
    return settled;
}


// WEBPACK FOOTER //
// ./src/contract/Wagers.js